<template>
    <v-row justify="center">
        <v-list-item

                color="primary"
                dark
                @click="dialog=true"
        >

            <v-list-item-content>
                <v-list-item-title class="comment">Register Applicant</v-list-item-title>
            </v-list-item-content>
        </v-list-item>


        <v-dialog
                v-model="dialog"
                width="450"
        >
            <v-card>
                <Loader :loading="loading" :message="message"/>
                <v-toolbar class="box"  @click.stop="dialog = false">
                    <v-icon>mdi-close</v-icon>
                    <v-toolbar-title>Close</v-toolbar-title>
                </v-toolbar>
                <div class="comment-content">
                    <v-card-title class="comment-heading">Become an innovator </v-card-title>
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form v-if="!submitted" @submit.prevent="handleSubmit(registerApplicant)">
                          <p class="err">{{serverResponse}}</p>
                        <div class="row">
                              <v-col>
                                <ValidationProvider name="First Name" rules="required" v-slot="{errors}">
                                  <span class="err">{{ errors[0] }}</span>
                                  <v-text-field outlined label="First Name" color="secondary" v-model="firstName">

                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col>
                                <ValidationProvider name="Last Name" rules="required" v-slot="{errors}">
                                  <span class="err">{{ errors[0] }}</span>
                                  <v-text-field outlined label="Last Name" color="secondary" v-model="lastName">

                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                          </div>

                              <ValidationProvider name="Email" rules="required|email" v-slot="{errors}">
                                  <span class="err">{{ errors[0] }}</span>
      <!--                            <v-row cols="12" sm="6" md="3">-->
                                      <v-text-field type="email"
                                                    v-model="email"
                                                    label="Email Address "
                                                    outlined
                                                    color="secondary">

                                      </v-text-field>
      <!--                            </v-row>-->
                              </ValidationProvider>

                          <ValidationProvider name="Phone Number"  :rules="{required:true,  regex: /^[0-9\s]+$/ }" v-slot="{errors}">
                            <span class="err">{{ errors[0] }}</span>
                            <vue-tel-input-vuetify outlined label="Phone Number"
                                                   v-model="phoneNumber" placeholder="Phone Number">

                            </vue-tel-input-vuetify>
                          </ValidationProvider>

                          <ValidationProvider name="Age range" rules="required" v-slot="{errors}">
                              <span class="err">{{ errors[0] }}</span>
                              <v-select
                                  :items="ageRangeArray"
                                  v-model="ageRange"
                                  label="Age Range"
                                  outlined
                              ></v-select>
                          </ValidationProvider>

                          <ValidationProvider name="Gender" rules="required" v-slot="{errors}">
                            <span class="err">{{ errors[0] }}</span>
                            <v-radio-group v-model="gender" row>
                              <span class="mr-3">Gender</span>
                              <v-radio color="#FF2E2E"  class="select_align mb-0"  label="Female" value="Female"></v-radio>
                              <v-radio  color="#FF2E2E"  class="select_align mb-0"  label="Male" value="Male"></v-radio>
                            </v-radio-group>
                          </ValidationProvider>

                          <ValidationProvider name="Terms and Conditions" :rules="{ required: { allowFalse: false } }" v-slot="{errors}">
                            <span class="err">{{ errors[0] }}</span>
                            <div class="d-flex">
                              <v-checkbox v-model="tAndC" class="select_align mb-0" color="#FF2E2E" ></v-checkbox>
                              <span class="mt-2"><TermsAndConditions/></span>
                            </div>
                          </ValidationProvider>

                          <v-card-actions>
                              <v-btn
                                      color="red"
                                      class="text--white"
                                      depressed
                                      x-large
                                      type="submit"
                                      width="100%"
                              >
                                  Apply
                              </v-btn>

                          </v-card-actions>
                        </form>
                    </ValidationObserver>

                </div>
            </v-card>
        </v-dialog>
    </v-row>
    
</template>

<script>
    import VueTelInputVuetify from "vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"
    import Loader from "@/components/Native/Elder/ElderDashboard/ElderDashboardBody/Loader";
    import TermsAndConditions from "@/components/Native/Elder/ElderDashboard/TermsAndConditions";
    import  axios from'axios';
    import {registerApplicant} from "@/services/ApiServices";
    export default {
        name: "RegisterApplicant",
        components:{
          TermsAndConditions,
            VueTelInputVuetify,
            Loader

        },
        data(){
            return{
                dialog:false,
                responseMsg:'',
                ageRangeArray:["Under 16","16-20","21-30","31-39","40 and above"],
                gender:"",
                tAndC:false,
                firstName:'',
                lastName:'',
                email:"",
                phoneNumber:'',
                ageRange:'',
                message:'Loading',
                loading:false,
                submitted:false,
                serverResponse:''


            }
        },
      methods:{
          registerApplicant(){
            this.dialog = false;
            const elderHeader = JSON.parse(sessionStorage.getItem('headers'))
            axios.post(registerApplicant,{
              firstName: this.firstName,
              lastName: this.lastName,
              phone: this.phoneNumber,
              // dialCode: "+234",
              email: this.email,
              gender: this.gender,
              ageRange: this.ageRange,
              tAndC: this.tAndC

            },{headers:elderHeader})
            .then(res=>{
              this.dialog=false
              alert(res.data.message)
            }).catch(err=>{
              this.dialog=true
              this.serverResponse=err.response.data.message;

            })

          }
      }
    }
</script>

<style scoped>
    .comment{
        font-family: IBM Plex Sans !important;
        font-style: normal !important ;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 20px !important;
        display: flex;
        align-items: center !important;
        letter-spacing: 0.02em;
        color: #000000;
    }
    .comment-box{
        background: rgba(67, 18, 136, 0.2);
        border-radius: 8px;
        padding: 3px;
    }
    .comment-heading{
        font-weight: 500!important;
        font-size: 30px !important;
        line-height: 33px!important;
        letter-spacing: -0.02em;
        color: #2B1C1C !important;
    }
    .err{
      color: red !important;
    }
    .box{
        box-shadow: none!important;
        cursor: pointer;
    }
    .comment-content{
        margin-left: 52px;
        margin-right: 52px;
        font-family: IBM Plex Sans !important;
        font-style: normal!important;
        font-weight: normal;

    }


</style>